import React, { useState } from 'react';
import { Globe, MessageSquare, Users, Newspaper } from 'lucide-react';
import ThreatFeedsOverview from './Overview';
import DarkWebChatters from './DarkWebChatters';
import ThreatActorDirectory from './ThreatActorDirectory';
import PublicNews from './PublicNews';

const ThreatFeedsIndex: React.FC = () => {
    const [activeTab, setActiveTab] = useState('overview');

    const tabs = [
        { id: 'overview', label: 'Overview', icon: Globe },
        { id: 'chatters', label: 'Underground Chatter', icon: MessageSquare },
        { id: 'actors', label: 'Adversary Registry', icon: Users },
        { id: 'news', label: 'Surface Web News', icon: Newspaper },
    ];

    return (
        <div className="flex h-screen bg-black text-white overflow-hidden font-mono relative">

            {/* Left Sidebar */}
            <div className="w-64 border-r border-[#1A1D24] p-4 flex flex-col justify-between bg-[#0A0B0E] relative z-20">

                {/* --- EXACT FIGMA LINEAR GRADIENT GLOW --- */}
                <div className="absolute top-0 right-0 w-[1px] h-full bg-gradient-to-b from-[#1A1D24] from-[0%] via-[#50A970] via-[54%] to-[#1A1D24] to-[100%] shadow-[0_0_15px_5px_rgba(80,169,112,0.25)] pointer-events-none z-50"></div>

                <div>
                    <div className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-4 px-2 mt-4">
                        Main
                    </div>
                    <div className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 px-2 mt-6">
                        Threats Feeds
                    </div>
                    <div className="flex flex-col gap-1">
                        {tabs.map((tab) => {
                            const Icon = tab.icon;
                            const isActive = activeTab === tab.id;
                            return (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    // IMPLEMENTED EXACT GLASS BLOCK AESTHETIC FROM MAIN SIDEBAR
                                    className={`relative flex items-center gap-3 px-3 py-2.5 rounded-lg text-xs font-medium transition-all duration-300 group overflow-hidden w-full ${isActive
                                        ? "bg-gradient-to-r from-[#50A970]/20 to-transparent backdrop-blur-md border border-[#50A970]/30 text-white shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                        : "text-slate-400 border border-transparent hover:text-white hover:bg-white/[0.02] hover:border-white/[0.05] hover:translate-x-1"
                                        }`}
                                >
                                    {isActive && (
                                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-[#50A970] rounded-r-full shadow-[0_0_12px_rgba(80,169,112,0.6)]"></div>
                                    )}
                                    <div className="flex items-center relative z-10 space-x-3">
                                        <Icon className={`w-4 h-4 flex-shrink-0 transition-transform duration-300 ${isActive ? "text-[#50A970] drop-shadow-[0_0_5px_rgba(80,169,112,0.5)]" : "text-slate-500 group-hover:text-slate-300"}`} />
                                        <span className="tracking-wide">{tab.label}</span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 overflow-y-auto bg-black relative z-10">
                {activeTab === 'overview' && <ThreatFeedsOverview />}
                {activeTab === 'chatters' && <DarkWebChatters />}
                {activeTab === 'actors' && <ThreatActorDirectory />}
                {activeTab === 'news' && <PublicNews />}
            </div>
        </div>
    );
};

export default ThreatFeedsIndex;